/* eslint-disable react/prop-types */
import React from 'react';
import type { TaskCardComponent } from '@tencent/ai-sidebar-sdk';
import classNames from 'classnames';
import i18n from '@i18next/i18n';
import styles from './tips-card.less';
import { ReplaceImageUtils } from '@src/slide/application/service/smart-replace-image/utils/replace-image-utils';

interface ITipsCardProps {
    title?: string;
    description: string;
    confirmText?: string;
    extraText?: string;
}

export const tipsCard: TaskCardComponent<ITipsCardProps> = ({ props, onResult, disable }) => (
    <div className={classNames({ [styles['card-disable']]: disable })}>
        <div className={styles['card-title']}>{props.title}</div>
        <div style={{ marginBottom: 8 }}>{props.description}</div>
        <div style={{ display: 'flex' }}>
            <button
                className={`ai-assistant-sdk-button ai-assistant-sdk-button--primary ${styles['card-button']}`}
                onClick={() => {
                    if (ReplaceImageUtils.getAllAiPictures().length ?? 0 > 0) {
                        onResult(true, props, props.confirmText);
                    } else {
                        onResult(false, props, i18n.t('很抱歉，当前文档里没有可以替换的图片'));
                    }
                }}
            >
                <div className={styles['tick-icon']} />
                {props.confirmText}
            </button>
            {props.extraText && (
                <button
                    className={`ai-assistant-sdk-button  ${styles['card-button']}`}
                    onClick={() => onResult(false, props, props.extraText)}
                >
                    {props.extraText}
                </button>
            )}
        </div>
    </div>
);
